/**
 * Feldbeschriftungen — Ersatz für das `[Caption(...)]`-Attribut, das
 * `IwmDataGridBase.GetColumnHeader` und `IwmAdminDialogAuswahlFields` per Reflexion auslesen.
 *
 * Die Zuordnung ist wie im Altclient gross-/kleinschreibungsabhängig
 * (`props.FirstOrDefault(e => e.Name == col.FieldName)`).
 */

import { containerCaptions } from './captions/container';
import { orderPositionCaptions } from './captions/orderPosition';
import { receiptCaptions } from './captions/receipt';
import { receiptAssignmentCaptions } from './captions/receiptAssignment';
import { EntityTypes } from './enums';
import {
  containerFieldNames,
  orderPositionFieldNames,
  receiptAssignmentFieldNames,
  receiptFieldNames,
} from './fieldTypes';

export type CaptionMap = Readonly<Record<string, string>>;

export { containerCaptions, orderPositionCaptions, receiptAssignmentCaptions, receiptCaptions };

const emptyCaptions: CaptionMap = {};
const emptyFieldNames: readonly string[] = [];

/** Beschriftungstabelle einer Entität; Entitäten ohne Beschriftungen liefern eine leere Tabelle. */
export function getCaptions(entity: EntityTypes): CaptionMap {
  switch (entity) {
    case EntityTypes.Bestellposition:
      return orderPositionCaptions;
    case EntityTypes.Container:
      return containerCaptions;
    case EntityTypes.Rechnung:
      return receiptCaptions;
    case EntityTypes.Rechnungszuordnung:
      return receiptAssignmentCaptions;
    default:
      return emptyCaptions;
  }
}

/** Feldliste einer Entität für die Feldauswahl der Administration. */
export function getFieldNames(entity: EntityTypes): string[] {
  switch (entity) {
    case EntityTypes.Bestellposition:
      return [...orderPositionFieldNames];
    case EntityTypes.Container:
      return [...containerFieldNames];
    case EntityTypes.Rechnung:
      return [...receiptFieldNames];
    case EntityTypes.Rechnungszuordnung:
      return [...receiptAssignmentFieldNames];
    default:
      return [...emptyFieldNames];
  }
}

/** Beschriftung eines Feldes; ohne Beschriftung wird der Feldname angezeigt. */
export function getCaption(entity: EntityTypes, fieldName: string): string {
  return getCaptions(entity)[fieldName] ?? fieldName;
}
